import { useMediaQuery } from '@mui/material';
import { IClientData, IVehicleData } from '../../createAndEdit/types';
import DetailVehicleAndClientCardsMobile from './mobile/DetailVehicleAndClientCardsMobile';

interface IDetailVehicleAndClientCardsProps {
  vehicleData?: IVehicleData;
  clientData?: IClientData;
}

const DetailVehicleAndClientCards = (props: IDetailVehicleAndClientCardsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <DetailVehicleAndClientCardsMobile
        vehicleData={props.vehicleData}
        clientData={props.clientData}
      />
    );
  }
  
  return (
    <div className="flex flex-row gap-4 mb-6 px-6 items-stretch">
      {/* Veículo */}
      <div className="flex-1 flex flex-col">
        <div className="font-bold mb-2">Veículo</div>
        <div className="border border-gray-200 rounded-md p-4 h-full">
          <div className="bg-gray-100 rounded-md p-4 h-full">
            <div className="flex flex-row items-start gap-4">
              <img src="/assets/images/truck.svg" alt="Veículo" className="w-10 h-10" />
              <div className="flex-1">
                {props.vehicleData && (
                  <div className="text-size-14">
                    {props.vehicleData.model && (
                      <div className="font-bold">
                        {props.vehicleData.model}
                        {props.vehicleData.year && ` ${props.vehicleData.year}`}{' '}
                        {props.vehicleData.licensePlate &&
                          ` | Placa: ${props.vehicleData.licensePlate}`}
                      </div>
                    )}
                    {props.vehicleData.chassis && (
                      <div className="mt-1">Chassi - {props.vehicleData.chassis}</div>
                    )}
                    {(props.vehicleData.odometer || props.vehicleData.hourmeter) && (
                      <div className="mt-1">
                        {props.vehicleData.odometer && `Odômetro: ${props.vehicleData.odometer}`}
                        {props.vehicleData.odometer && props.vehicleData.hourmeter && ' | '}
                        {props.vehicleData.hourmeter && `Horímetro: ${props.vehicleData.hourmeter}`}
                      </div>
                    )}
                    {props.vehicleData.contractNumber && (
                      <div className="mt-1 font-bold">
                        Volks total Prev: Contrato #{props.vehicleData.contractNumber}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {props.vehicleData?.inWarranty && (
                <span className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-size-12 font-bold whitespace-nowrap mt-1">
                  Em garantia
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Cliente */}
      <div className="flex-1 flex flex-col">
        <div className="font-bold mb-2">Cliente</div>
        <div className="border border-gray-200 rounded-md p-4 h-full">
          {props.clientData && (
            <div className="text-size-14 h-full">
              {props.clientData.name && (
                <div className="font-bold mb-2">{props.clientData.name}</div>
              )}
              <div className="flex flex-row justify-between">
                <div>{props.clientData.phone || ''}</div>
                <div className="text-right">{props.clientData.email || ''}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailVehicleAndClientCards;
